import React from 'react';
import { get } from 'lodash';
import { Breadcrumbs, Crumb } from 'components/core/Breadcrumbs';

import './facilityBreadcrumbs.scss';

const FacilityBreadcrumbs = (props) => {
	const { facility } = props;
	const enhancedProps = {
		className: 'facility-breadcrumbs',
		location: facility.seoLocation,
		cityUrl: get(facility, 'url.city'),
		stateUrl: get(facility, 'url.state'),
		crumbs:
			facility.name && facility.url
				? [
						<Crumb
							key="facility"
							label={facility.name}
							href={facility.url.facility}
							isLast
						/>,
					]
				: [],
	};
	return (
		<Breadcrumbs
			{...props}
			{...enhancedProps}
		/>
	);
};

export default FacilityBreadcrumbs;
